import { LocalesEffects } from './locales/locales.effects';

export const SharedEffects = [
    LocalesEffects
];

export {
    LocalesEffects
};
